const ChatLoading = () => {
    return (
        <div className='skeleton_block'>
            <div id='skeleton' className='skeleton_unit' ></div>
            <div id='skeleton'  className='skeleton_unit' ></div>
            <div id='skeleton'  className='skeleton_unit' ></div>
            <div id='skeleton'  className='skeleton_unit' ></div>
            <div id='skeleton'  className='skeleton_unit' ></div>
            <div id='skeleton'  className='skeleton_unit' ></div>
            <div id='skeleton'  className='skeleton_unit' ></div>
            <div id='skeleton'  className='skeleton_unit' ></div>
            <div id='skeleton'  className='skeleton_unit' ></div>
            <div id='skeleton'  className='skeleton_unit' ></div>
            <div id='skeleton'  className='skeleton_unit' ></div>
            <div id='skeleton'  className='skeleton_unit' ></div>
        </div>
    );
};

export default ChatLoading;
